import { render } from "./ReSettingSMSComponent.vue?vue&type=template&id=274e77a4&scoped=true"
import script from "./ReSettingSMSComponent.vue?vue&type=script&lang=js"
export * from "./ReSettingSMSComponent.vue?vue&type=script&lang=js"

import "./ReSettingSMSComponent.vue?vue&type=style&index=0&id=274e77a4&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274e77a4"]])

export default __exports__